import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import {
    Box,
    Button,
    Container,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Alert,
} from '@mui/material';
import * as invoiceActions from '../actions/invoice'; // adjust path to your action file
import Immutable from 'seamless-immutable';
import { getPaymentFrequency } from './InvoiceDetailsComponent';
import clientService from '../services/client'
import FreezeBanner from './boxes/FreezeBanner';
import { withTranslation } from 'react-i18next';


class PlanReactivation extends React.Component {
     constructor(props) {
        super(props);

        this.state = {
            employees: [],
            plans: [],
            loading: false,
        };
    }
    componentDidMount() {
        const { dispatch, user, invoices, selectedInvoice, history } = this.props;
        const invoiceId = invoices[0]?.reference_code;
        dispatch(
            invoiceActions.getClientInvoiceByRefCode(
                selectedInvoice.reference_code || invoiceId,
                user.credentials.accessToken,
                user.companyInfo.id
            )
        );
        const queryData = {invoice_ref_code: selectedInvoice.reference_code || invoiceId}

        clientService
            .getStaff(user.credentials.accessToken, user.companyInfo.id, queryData)
            .then((response) =>{
                this.setState({
                    isLoading: false,
                    employees: response.data
                })
            }
            )
            .catch((error) => {
                // this.setLoading(false);
            });

         clientService.getAllPlans(user.preferences.selectedClient).then(plans => {
                    this.setState({
                        plans: plans || [],
                    });
                })
        }

        onCheckout = () => {
            if (this.props.selectedInvoice?.is_frozen) return;
            this.setState({
                loading: true
            })
            const { user, selectedInvoice } = this.props;
            const productId =  (product) => {
               if(this.state.plans && this.state.plans.filter(plan => plan.name === product.name).length) {
                return this.state.plans.filter(plan => plan.name === product.name)[0].id
               }
            }
            const meta = {
                payment_frequency: getPaymentFrequency(selectedInvoice?.payment_frequency_id),
                for: 'sme',
                callback_url:
                    process.env.REACT_APP_CONGRATS_URL ||
                    'https://client.staging.reliancehmo.com/dashboard/congratulations',
                client: {
                    id: user.preferences.selectedClient
                }
            };

            const cart = selectedInvoice.products.map(product => {
                const cartItem = {
                    "name": product.name,
                    "no_of_enrollees": product.no_of_enrollees,
                    "price": +selectedInvoice.total_price,
                    "product_id": productId(product)
                }
                if(!productId(product)) return null
                return cartItem
            })
            const request = {
                cart: cart.filter(item => item !== null),
                meta
            };
            this.setState({
                isSubmitting: true
            });
    
            clientService.purchasePlan(JSON.stringify(request), user.credentials.accessToken).then(
                (response) => {
                    if (response.authorization_url !== '') {
                        window.location.href = response.authorization_url;
                    } else {
                        this.props.history.push('/dashboard/invoices');
                    }
                },
                (error) => {
                    this.setState({
                        error: {
                            message: error.response.data.message,
                            isSubmitting: false
                        }
                    });
                }
            );
        };
    

    render() {
        const { selectedInvoice, history, t } = this.props;
        const plans = selectedInvoice?.products || [];
        const employees = this.state.employees || [];
        const isFrozen = !!selectedInvoice?.is_frozen;

        return (
            <Container maxWidth="sm" sx={{ mt: 6 }} height="100vh" overflow-y="scroll">
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    {t("plan.reactivationPageTitle")}
                </Typography>

                <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        {t("plan.detailsSectionTitle")}
                    </Typography>

                    {/* Plan Items */}
                    <Box sx={{ mb: 3 }}>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography color="rgba(174, 174, 174, 1)" variant="body1">
                                    {t("plan.planName")}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography color="rgba(174, 174, 174, 1)" variant="body1">
                                    {t("plan.quantity")}
                                </Typography>
                            </Grid>
                        </Grid>
                        {plans.map((plan, idx) => (
                            <Grid container key={idx} justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="body1">{plan.name}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body1">{t("common.quantity", { quantity: plan.no_of_enrollees })}</Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Box>

                    <Divider color="rgba(174, 174, 174, 1)" sx={{ my: 2 }} />

                    {/* Dates */}
                    <Box sx={{ mb: 2 }}>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography color="rgba(174, 174, 174, 1)" variant="body1">
                                    {t("plan.durationSectionTitle")}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="body1" color="text.secondary">
                                    {t("plan.effectiveStartDate")}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1">
                                    {selectedInvoice?.start_date ? t("common.date", { date: selectedInvoice?.start_date }) : 'N/A'}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="body1" color="text.secondary">
                                    {t("plan.expiryDate")}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1">
                                    {selectedInvoice?.end_date ? t("common.date", { date: selectedInvoice?.end_date }) : 'N/A'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider color="rgba(174, 174, 174, 1)" sx={{ my: 2 }} />

                    {/* Payment Frequency */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body1" color="text.secondary">
                            {t("plan.paymentFrequency")}
                        </Typography>
                        <Typography variant="body1" style={{textTransform: 'capitalize'}}>
                            {t(`common.${getPaymentFrequency(selectedInvoice?.payment_frequency_id).toLowerCase()}`) ||
                                t("common.annually")}
                        </Typography>
                    </Box>

                    <Divider color="rgba(174, 174, 174, 1)" sx={{ my: 2 }} />

                    {/* Employees Table */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            {t("plan.employeesInsuredSectionTitle")}
                        </Typography>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell>{t("plan.employeeInsuredTableNameColumnTitle")}</TableCell>
                                    <TableCell>{t("plan.employeeInsuredTablePlanColumnTitle")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {employees.map((emp, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>{emp.first_name}  {emp.last_name}</TableCell>
                                        <TableCell>{emp.product_name}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>

                    {/* Total */}
                    <Box textAlign="right" sx={{ mb: 3 }}>
                        <Typography variant="subtitle1" fontWeight="Bold">
                            {t("plan.totalAmount")}
                        </Typography>
                        <Typography variant="h4" fontWeight="Bold" color="success.main">
                            {t("common.amount", { amount: selectedInvoice?.total_price ?? 0})}
                        </Typography>
                    </Box>

                    {isFrozen && <FreezeBanner sx={{ mt: 4 }} />}

                    {/* Buttons */}
                    <Box display="flex" gap={2} mt={2}>
                        <Button
                            variant="outlined"
                            color="inherit"
                            fullWidth
                            sx={{
                                borderRadius: '40px',
                                height: '35px',
                                border: '1px solid rgba(174, 174, 174, 1)'
                            }}
                            onClick={() => history.goBack()}
                        >
                            {t("plan.cancelButtonText")}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ borderRadius: '45px', height: '35px' }}
                            onClick={this.onCheckout}
                            disabled={this.state.loading || isFrozen}
                        >
                            {t("plan.reactivatePlanButtonText")}
                        </Button>
                    </Box>

                    {/* Alert Box */}
                    <Alert severity="info" sx={{ mt: 4 }}>
                        <Typography variant="body1">
                            <strong>{t("plan.questionOnPlanActivation")}</strong>
                            <br />
                            {t("plan.questionOnPlanActivationReachout")}
                        </Typography>
                        <Box mt={1}>
                            <Link to="/dashboard/help" underline="hover">
                                {t("plan.contactAgentLinkText")}
                            </Link>
                        </Box>
                    </Alert>
                </Paper>
            </Container>
        );
    }
}

// Map Redux state to
const mapStateToProps = ({ session, invoice }) => ({
    user: session.user,
    selectedInvoice: invoice.selectedInvoice
        ? Immutable.asMutable(invoice.selectedInvoice, { deep: true })
        : {},
    isFetching: invoice.isFetching
});

const PlanReactivationWithTranslation = withTranslation()(PlanReactivation);
export default withRouter(connect(mapStateToProps)(PlanReactivationWithTranslation));
